/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TierCode } from './TierCode';
import {
    TierCodeFromJSON,
    TierCodeFromJSONTyped,
    TierCodeToJSON,
    TierCodeToJSONTyped,
} from './TierCode';

/**
 * 
 * @export
 * @interface ChangeBillingSubscriptionRequest
 */
export interface ChangeBillingSubscriptionRequest {
    /**
     * 
     * @type {TierCode}
     * @memberof ChangeBillingSubscriptionRequest
     */
    tierCode: TierCode;
    /**
     * 
     * @type {string}
     * @memberof ChangeBillingSubscriptionRequest
     */
    billingPeriod?: ChangeBillingSubscriptionRequestBillingPeriodEnum;
}


/**
 * @export
 */
export const ChangeBillingSubscriptionRequestBillingPeriodEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type ChangeBillingSubscriptionRequestBillingPeriodEnum = typeof ChangeBillingSubscriptionRequestBillingPeriodEnum[keyof typeof ChangeBillingSubscriptionRequestBillingPeriodEnum];


/**
 * Check if a given object implements the ChangeBillingSubscriptionRequest interface.
 */
export function instanceOfChangeBillingSubscriptionRequest(value: object): value is ChangeBillingSubscriptionRequest {
    if (!('tierCode' in value) || value['tierCode'] === undefined) return false;
    return true;
}

export function ChangeBillingSubscriptionRequestFromJSON(json: any): ChangeBillingSubscriptionRequest {
    return ChangeBillingSubscriptionRequestFromJSONTyped(json, false);
}

export function ChangeBillingSubscriptionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeBillingSubscriptionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tierCode': TierCodeFromJSON(json['tierCode']),
        'billingPeriod': json['billingPeriod'] == null ? undefined : json['billingPeriod'],
    };
}

export function ChangeBillingSubscriptionRequestToJSON(json: any): ChangeBillingSubscriptionRequest {
    return ChangeBillingSubscriptionRequestToJSONTyped(json, false);
}

export function ChangeBillingSubscriptionRequestToJSONTyped(value?: ChangeBillingSubscriptionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tierCode': TierCodeToJSON(value['tierCode']),
        'billingPeriod': value['billingPeriod'],
    };
}

